import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './SeeAllSlide.scss';
const SeeAllSlide = (_param)=>{
    var { title, style, seeAllUrl, component: ButtonComponent, containerClassName } = _param, props = _object_without_properties(_param, [
        "title",
        "style",
        "seeAllUrl",
        "component",
        "containerClassName"
    ]);
    const { t } = useTranslation();
    const contex = /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['see-all-slide'], containerClassName),
        style: style
    }, /*#__PURE__*/ React.createElement("span", null, title || t('common.seeAll')));
    return ButtonComponent ? /*#__PURE__*/ React.createElement(ButtonComponent, props, contex) : /*#__PURE__*/ React.createElement("a", {
        href: seeAllUrl
    }, contex);
};
export default SeeAllSlide;
